import React from 'react';
import {
  Button, FormGroup, Label, CardText,
  Input, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import emptycart from "../../assets/img/empty-shoppingcart.png";
import { api } from "../../api/api.js";
import apifunctions from "../../api/functions.js";
import htmlFormat from "../../functions/functions.js";
import { CartContext } from "../../components/ParadigmaCartProvider";
import CantidadSelector from "../../components/CantidadSelector";
import imgOfertaTiempo from '../../assets/img/Oferta-Tiempo.png';
import imgOfertaVolumen from '../../assets/img/Oferta-Cajas.png';
import moment from 'moment';
import { NotificationManager } from 'react-notifications';

const ModalExitoCrearPedido = (props) => {
  return (
    <Modal centered isOpen={props.isOpen} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>Pedido Creado</ModalHeader>
      <ModalBody>
        El pedido ha sido creado exitosamente.
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={props.onClickBtn}>Ver Mis Pedidos</Button>
      </ModalFooter>
    </Modal>
  );
};

export default class Carrito extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cartItems: [],
      idUser: 0,
      subtotal: 0,
      observaciones: '',
      loaded: false,
      redirectPedidos: false,
      enabled: true,
      modalRedirect: false,
      observaciones: '',
      email: '',
      showEmailField: false,
      errorMsg: '',
    };
    this.lock = false;
  }

  ItemsCallback(data, removeItems) {
    if (this.lock == false) {
      this.lock = true;
      let loaded = true;
      let antiguoCarrito = [...this.state.cartItems];
      let nuevoCarrito = data.data && data.data.productos ? data.data.productos : [];
      this.setState(
        prevState => {
          this.lock = false;
          let compare = (a, b) => { return a.code > b.code ? 1 : a.code < b.code ? -1 : 0 };
          prevState.loaded = loaded;
          prevState.cartItems = nuevoCarrito;
          prevState.cartItems.sort(compare);
          prevState.subtotal = (data.data && data.data.SubTotal ? data.data.SubTotal : 0);
          return prevState;
        }
      );
    }
  }

  downloadPDF() {
    let items = this.state.cartItems.map((item) => ({ code: item.code, quantity: item.quantity }));
    apifunctions.get(
      api.pedidos.generar.presupuesto, btoa(JSON.stringify(items)), null, null,
      (data) => {
        var a = document.createElement('a');
        var url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
        a.href = url;
        a.download = 'Cotizacion.pdf';
        document.body.append(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      },
      (data) => { },
      (data) => { },
    );
  }

  getErrorMessageFromResponse(response) {
    if (!response) {
      return 'No pudimos crear el pedido. Verifique su conexión e intente nuevamente.';
    }
    if (typeof response === 'string') return response;
    if (response.detail) return response.detail;
    if (response.errors) {
      if (Array.isArray(response.errors)) {
        const first = response.errors.find((item) => typeof item === 'string' || (item && item.detail));
        if (typeof first === 'string') return first;
        if (first && first.detail) return first.detail;
      }
      if (typeof response.errors === 'string') return response.errors;
    }
    if (response.meta && response.meta.message) {
      return response.meta.message;
    }
    return 'No pudimos crear el pedido. Refresque el carrito y vuelva a intentarlo.';
  }

  handlePedidoError(response) {
    const message = this.getErrorMessageFromResponse(response);
    NotificationManager.error(message, 'Error al generar el pedido');
    this.setState({ enabled: true, modalRedirect: false, errorMsg: message });
  }

  generarPedido(removeItems) {
    let items = this.state.cartItems.map((item) => ({ code: item.code, quantity: item.quantity }));
    this.setState(
      { enabled: false },
      () => apifunctions.post(
        api.pedidos.generar.pedido, null,
        { hash: btoa(JSON.stringify(items)), observaciones: this.state.observaciones, email: this.state.email, },
        (data) => {
          this.props.hide && this.props.hide();
          const toRemove = this.state.cartItems.map(x => x.code);
          // Vaciar carrito del servidor y limpiar local
          apifunctions.post(api.cart.base + '/empty', null, {}, () => {
            removeItems(toRemove, () => this.setState({ cartItems: [], subtotal: 0, observaciones: "", enabled: true, modalConfirmaCreacionPedido: false, errorMsg: "" }, () => this.toggleModalRedirect()));
          });
        },
        (data) => this.handlePedidoError(data),
        (data) => this.handlePedidoError(data),
      )
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show == false && nextProps.show == true) {
      apifunctions.post(
        api.auth.profile, null, {},
        (res) => {
          let email = '';
          let showEmailField = true;
          try {
            if (res.meta.allowed == true && res.data.Email != undefined && res.data.Email != null && res.data.Email.length > 0 && res.data.Email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) != null) {
              email = res.data.Email;
              showEmailField = false;
            }
          } catch (e) {
            email = '';
            showEmailField = true;
          }
          this.setState({ email: email, showEmailField: showEmailField });
        },
        (data) => this.setState({ email: '', showEmailField: true }),
        (data) => this.setState({ email: '', showEmailField: true }),
      );
    }
  }

  toggleModalRedirect() {
    document.querySelector('html').scrollTo(0, 0);
    this.setState(
      { modalRedirect: !this.state.modalRedirect },
      () => { if (this.state.modalRedirect == true) setTimeout(() => this.setState({ modalRedirect: false }), 2500) }
    );
    return true;
  }

  render() {
    const validarEmail = (mail) => {
      if (mail.indexOf("@") == -1 || mail.indexOf(".") == -1) {
        return false;
      } else {
        clearTimeout(this.validaTimeout);
        this.validaTimeout = setInterval(
          () => {
            clearTimeout(this.validaTimeout);
            this.setState({ validaMail: mail.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) != null });
          },
          1000
        );
        return true;
      }
    };
    const today = moment(Date.now());
    let distintoCarrito = (c1, c2) => {
      let equalsObjects = (a, b) => a.code === b.code && a.quantity === b.quantity;
      let estaItem = (item, array) => {
        let esta = false;
        array.forEach(item2 => esta = equalsObjects(item, item2) == true ? true : esta);
        return esta;
      }
      let C1aC2 = true;
      c1.forEach(itemc1 => C1aC2 = estaItem(itemc1, c2) == false ? false : C1aC2);
      let C2aC1 = true;
      c2.forEach(itemc2 => C2aC1 = estaItem(itemc2, c1) == false ? false : C2aC1);
      return (C1aC2 & C2aC1) == false;
    }
    const {
      loaded, enabled, subtotal, observaciones, email, showEmailField, errorMsg,
      user_id, cartItems, redirectPedidos, modalRedirect,
    } = this.state;
    const { show, hide } = this.props;
    if (redirectPedidos == true) {
      return (<Redirect to='/historialpedidos' />);
    }
    else {
      let existeOferta = false;
      cartItems.forEach((item, i) => {
        existeOferta = (moment(Date.now()) >= moment(item.OfertaPeriodo_FechaDesde) && moment(Date.now()) <= moment(item.OfertaPeriodo_FechaHasta)) == true ? true : existeOferta;
        existeOferta = (item.OfertaNxM_Cantidad > 0 && item.OfertaNxM_Cantidad <= item.quantity) ? true : existeOferta;
      });
      return (
        <React.Fragment>
          <ModalExitoCrearPedido isOpen={modalRedirect} toggle={() => this.toggleModalRedirect()} onClickBtn={() => this.setState({ redirectPedidos: true })} />
          <CartContext.Consumer>
            {
              ({ setItem, quantity, removeItem, removeItems, items, loading, refresh, selectedItems }) => {
                if (
                  loading == false && (
                    loaded == false ||
                    distintoCarrito(
                      selectedItems,
                      cartItems.map(item => ({ code: item.code, quantity: item.quantity }))
                    )
                  )
                ) {
                  items(data => this.ItemsCallback(data, removeItems));
                }
                return (
                  <Modal className={cartItems.length == 0 ? "modal-md" : "modal-lg"} centered isOpen={show} toggle={hide}>
                    <ModalHeader className="text-center" toggle={hide}>Creación de Pedido</ModalHeader>
                    <ModalBody>
                      {
                        errorMsg &&
                        <div className="alert alert-danger" role="alert">
                          {errorMsg}
                        </div>
                      }
                      {
                        cartItems.length == 0 ?
                          <React.Fragment>
                            <div className="text-center p-5">
                              <img width={'auto'} height={70} src={emptycart} alt={"Carrito vacio"} />
                              <h4>Su lista esta Vacia</h4>
                            </div>
                          </React.Fragment>
                          :
                          <React.Fragment>
                            <CardText className="h5 pb-2">Detalle</CardText>
                            <div className="pedido-detalle">
                              <div className="pedido-itemscontainer">
                                {
                                  cartItems.sort((a, b) => (a.Codigo > b.Codigo ? 1 : (a.Codigo < b.Codigo ? -1 : 0))).map(
                                    (item, index) => {
                                      return (
                                        <div className="row border-top border-info overflow-auto">
                                          {
                                            existeOferta == true &&
                                            <div className="col-2 p-0 py-1 text-center">
                                              {
                                                (moment(Date.now()) >= moment(item.OfertaPeriodo_FechaDesde) && moment(Date.now()) <= moment(item.OfertaPeriodo_FechaHasta)) == true &&
                                                <img src={imgOfertaTiempo} height="65" />
                                              }
                                              {
                                                (moment(Date.now()) >= moment(item.OfertaPeriodo_FechaDesde) && moment(Date.now()) <= moment(item.OfertaPeriodo_FechaHasta)) == false &&
                                                (item.OfertaNxM_Cantidad > 0 && item.OfertaNxM_Cantidad <= item.quantity) == true &&
                                                <img src={imgOfertaVolumen} height="65" />
                                              }
                                            </div>
                                          }
                                          <div className={existeOferta == true ? "col-7 p-0 pl-3 text-left" : "col-9 p-0 pl-3 text-left"}>
                                            <div className="" title={item.Titulo}><strong>{(item.Titulo).toUpperCase()}</strong></div>
                                            <div className=""><strong>{item.Codigo.toUpperCase()}</strong></div>
                                            <div>
                                              Un total de <strong>${htmlFormat.FormatPrice(item.totalPrice)}</strong> por {item.quantity} {item.quantity == 1 ? "unidad." : "unidades."}
                                            </div>
                                          </div>
                                          <div className="col-2 p-0 text-right">
                                            <CantidadSelector
                                              className=""
                                              onChange={(quantity) => setItem(item.code, quantity, () => this.setState({ loaded: false, cantidad: quantity }))}
                                              cantidad={item.quantity}
                                              cantidadDisponible={999}
                                            />
                                          </div>
                                          <div className="col-1 p-0 pt-1 text-left">
                                            <Button color="secondary"
                                              className=""
                                              onClick={
                                                (e) => {
                                                  e.preventDefault();
                                                  removeItem(item.code, () => this.setState({ loaded: false }));
                                                }
                                              }
                                            ><i className="fa fa-trash" aria-hidden="true"></i></Button>
                                          </div>
                                        </div>
                                      )
                                    }
                                  )
                                }
                              </div>
                            </div>
                            <FormGroup className="">
                              <CardText className="text-right p-2 h5">Subtotal: <strong>${htmlFormat.FormatPrice(subtotal)}</strong></CardText>
                              <CardText className="px-2 text-center h6"><strong>EL PRECIO INDICADO EN EL SUBTOTAL NO INCLUYE DESCUENTOS COMERCIALES NI IMPUESTOS</strong></CardText>
                              <Label className="h5 py-2" for="observaciones">Observaciones</Label>
                              <Input
                                id="observaciones" name="observaciones" type="textarea" placeholder="Dejenos un comentario de posible interes acerca del pedido a crear."
                                onChange={(evt) => this.setState({ observaciones: evt.target.value ? evt.target.value : "" })}
                              />
                            </FormGroup>
                          </React.Fragment>
                      }
                    </ModalBody>
                    {
                      cartItems.length > 0 &&
                      <ModalFooter>
                        <Button color="success" disabled={enabled == false || validarEmail(email) == false} onClick={() => cartItems.length > 0 && this.generarPedido(removeItems)}>Confirmar Pedido <i className="fa fa-thumbs-o-up" aria-hidden="true"></i></Button>
                        <Button color="secondary" onClick={hide}>Cancelar <i className="fa fa-times" aria-hidden="true"></i></Button>
                      </ModalFooter>
                    }
                  </Modal>
                );
              }
            }
          </CartContext.Consumer>
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Carrito/Carrito.js